/* KBN — Rezeptbuch Lead-Magnet Signup
 * --------------------------------------------------------------
 * Custom-Element <recipebook-signup> für die Landing-Section
 * sections/recipebook-lead-magnet.liquid. Abgespecktes Pattern von
 * kbn-gift-newsletter.js: KEINE Trigger/Apparition-Logik (die Section
 * ist statischer Page-Content), nur:
 *
 *   1. Form-Submit → POST {worker}/newsletter-subscribe
 *      Body: { email, locale, language, country, list_id, event_name,
 *              customer_tag, source: 'recipebook-page', section_id }
 *      → Worker: Klaviyo-DOI-Subscribe + Event 'Recipe Book Requested'
 *        (Event feuert bei JEDEM Submit, Worker dedupliziert 1×/Tag —
 *        Mehrfach-Zusendung läuft über den Metric-Flow, s. Bauplan).
 *   2. Form → Success State-Wechsel (im selben Card-Container).
 *   3. "Zur Mailbox"-Button → Posteingang-Deeplink (Provider-Map).
 *   4. Optionaler Format-Umschalter (Download/Druck) sobald die
 *      Section ein Druck-Produkt gesetzt hat (Phase 2).
 *
 * Bewusst KEIN localStorage-Gate: Wiederholtes Absenden ist gewollt
 * (Kunde kann sich den Download-Link erneut schicken lassen).
 *
 * Im Theme-Editor: data-editor-state="success" zeigt den Success-State
 * sofort (Editor-Vorschau-Setting der Section).
 */
(function () {
  'use strict';

  if (window.__KBN_RECIPEBOOK_INIT__) return;
  window.__KBN_RECIPEBOOK_INIT__ = true;

  var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function RecipebookSignup() {
    return Reflect.construct(HTMLElement, [], RecipebookSignup);
  }
  RecipebookSignup.prototype = Object.create(HTMLElement.prototype);
  RecipebookSignup.prototype.constructor = RecipebookSignup;
  Object.setPrototypeOf(RecipebookSignup, HTMLElement);

  RecipebookSignup.prototype.connectedCallback = function () {
    if (this._mounted) return;
    this._mounted = true;

    var ds = this.dataset;
    this.cfg = {
      sectionId:   ds.sectionId || 'recipebook',
      workerUrl:   (ds.workerUrl || '').replace(/\/+$/, ''),
      listId:      ds.listId || '',
      eventName:   ds.eventName || '',
      customerTag: ds.customerTag || '',
      locale:      ds.locale || '',
      language:    ds.language || '',
      country:     ds.country || '',
      editorState: ds.editorState || ''
    };

    this.els = {
      form:        this.querySelector('[data-rb-form]'),
      emailInput:  this.querySelector('[data-rb-email]'),
      submitBtn:   this.querySelector('[data-rb-submit]'),
      submitLabel: this.querySelector('[data-rb-submit-label]'),
      errorEl:     this.querySelector('[data-rb-error]'),
      successEl:   this.querySelector('[data-rb-success]'),
      mailboxBtn:  this.querySelector('[data-rb-mailbox]'),
      toggleBtns:  this.querySelectorAll('[data-rb-mode]'),
      panels:      this.querySelectorAll('[data-rb-panel]')
    };

    this._bindForm();
    this._bindToggle();

    // Editor-Vorschau: Success-State sofort zeigen (kein echter Submit).
    if (this.cfg.editorState === 'success') {
      this._switchToSuccess();
    }
  };

  // -----------------------------------------------------------------
  // Format-Umschalter (Download / Druck) — nur aktiv wenn die Section
  // ein Druck-Produkt gesetzt hat (sonst existieren die Buttons nicht).
  // -----------------------------------------------------------------
  RecipebookSignup.prototype._bindToggle = function () {
    var self = this;
    if (!this.els.toggleBtns.length) return;

    for (var i = 0; i < this.els.toggleBtns.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          self._setMode(btn.getAttribute('data-rb-mode'));
        });
      })(this.els.toggleBtns[i]);
    }
  };

  RecipebookSignup.prototype._setMode = function (mode) {
    var i;
    for (i = 0; i < this.els.toggleBtns.length; i++) {
      var btn = this.els.toggleBtns[i];
      var active = btn.getAttribute('data-rb-mode') === mode;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    }
    for (i = 0; i < this.els.panels.length; i++) {
      var panel = this.els.panels[i];
      if (panel.getAttribute('data-rb-panel') === mode) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    }
  };

  // -----------------------------------------------------------------
  // Submit → Worker
  // -----------------------------------------------------------------
  RecipebookSignup.prototype._bindForm = function () {
    var self = this;
    if (!this.els.form) return;
    this.els.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self._submit();
    });
  };

  RecipebookSignup.prototype._submit = function () {
    var self = this;
    var email = (this.els.emailInput.value || '').trim().toLowerCase();

    this._clearError();

    if (!email) {
      this._showError('Bitte gib deine E-Mail-Adresse ein.');
      return;
    }
    if (!EMAIL_REGEX.test(email)) {
      this._showError('Diese E-Mail-Adresse sieht ungültig aus.');
      return;
    }
    if (!this.cfg.workerUrl) {
      this._showError('Anmeldung nicht konfiguriert. Bitte später erneut versuchen.');
      return;
    }

    this._setSubmitting(true);

    var payload = {
      email: email,
      locale: this.cfg.locale,
      language: this.cfg.language,
      country: this.cfg.country,
      source: 'recipebook-page',
      section_id: this.cfg.sectionId
    };
    if (this.cfg.listId)      payload.list_id = this.cfg.listId;
    if (this.cfg.eventName)   payload.event_name = this.cfg.eventName;
    if (this.cfg.customerTag) payload.customer_tag = this.cfg.customerTag;

    fetch(this.cfg.workerUrl + '/newsletter-subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'omit',
      keepalive: true
    })
    .then(function (res) {
      // 409 (already subscribed) = Erfolg: der Metric-Flow schickt den
      // Link erneut — der Kunde soll keinen Fehler sehen.
      if (res.ok || res.status === 409) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          return { ok: true, data: data };
        });
      }
      return res.json().catch(function () { return {}; }).then(function (data) {
        return { ok: false, status: res.status, data: data };
      });
    })
    .then(function (result) {
      self._setSubmitting(false);
      if (result.ok) {
        self._onSuccess(email);
      } else {
        var msg = (result.data && result.data.error)
          ? self._humanError(result.data.error)
          : 'Etwas ist schief gelaufen. Bitte versuche es in einem Moment erneut.';
        self._showError(msg);
      }
    })
    .catch(function (err) {
      self._setSubmitting(false);
      self._showError('Verbindung fehlgeschlagen. Prüfe deine Internetverbindung und versuche es erneut.');
      // eslint-disable-next-line no-console
      console.warn('[kbn-recipebook] submit error', err);
    });
  };

  RecipebookSignup.prototype._humanError = function (code) {
    var map = {
      'invalid_email':   'Diese E-Mail-Adresse sieht ungültig aus.',
      'rate_limited':    'Bitte warte einen Moment und versuche es erneut.',
      'invalid_payload': 'Eingabe ungültig. Bitte prüfe deine E-Mail-Adresse.'
    };
    return map[code] || 'Etwas ist schief gelaufen. Bitte versuche es erneut.';
  };

  RecipebookSignup.prototype._onSuccess = function (email) {
    this._setMailboxLink(email);
    this._animateToSuccess();
    document.dispatchEvent(new CustomEvent('kbn:recipebook:submitted', {
      detail: { email: email }
    }));
  };

  // Instant-Wechsel: Editor-Vorschau + Reduced-Motion-Fallback.
  RecipebookSignup.prototype._switchToSuccess = function () {
    if (this.els.form) this.els.form.setAttribute('hidden', '');
    if (this.els.successEl) {
      this.els.successEl.removeAttribute('hidden');
      // Fokus für Tastatur-/Screenreader-Nutzer auf den Success-Block
      // ziehen (aria-live am Container announced den Inhalt zusätzlich).
      this.els.successEl.setAttribute('tabindex', '-1');
      this.els.successEl.focus({ preventScroll: false });
    }
  };

  // Cross-Fade Form → Success, Pattern vom Gift-Popup: Card-Höhe als
  // min-height einfrieren (kein Layout-Sprung), Success-Panel einblenden,
  // .is-tearing triggert die CSS-Keyframes, nach 540ms finaler State.
  RecipebookSignup.prototype._animateToSuccess = function () {
    var self = this;
    var card = this.querySelector('[data-rb-panel="download"]');

    var prefersReducedMotion = (window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (!card || prefersReducedMotion) {
      this._switchToSuccess();
      return;
    }
    if (this._isTearing) return;
    this._isTearing = true;

    card.style.minHeight = card.offsetHeight + 'px';
    if (this.els.successEl) this.els.successEl.removeAttribute('hidden');

    requestAnimationFrame(function () {
      self.classList.add('is-tearing');
      self._tearTimer = setTimeout(function () {
        if (self.els.form) self.els.form.setAttribute('hidden', '');
        self.classList.remove('is-tearing');
        self.classList.add('is-success');
        self._isTearing = false;
        self._tearTimer = null;
        // min-height bleibt gepinnt: Card behält die Formular-Höhe,
        // damit die Seite beim State-Wechsel nicht springt.
        if (self.els.successEl) {
          self.els.successEl.setAttribute('tabindex', '-1');
          self.els.successEl.focus({ preventScroll: true });
        }
      }, 540);
    });
  };

  // Posteingang-Deeplink für den "Zur Mailbox"-Button — gleiche Strategie
  // wie im Gift-Popup: bekannte Provider → Webmail-Inbox, sonst iOS/Android
  // Mail-App-Scheme, sonst mailto: (Default aus dem Liquid) belassen.
  RecipebookSignup.prototype._setMailboxLink = function (email) {
    var btn = this.els.mailboxBtn;
    if (!btn) return;
    if (this._mailboxApplied) return;

    var domain = (String(email || '').split('@')[1] || '').toLowerCase();
    var WEBMAIL = {
      'gmail.com': 'https://mail.google.com/mail/u/0/#inbox',
      'googlemail.com': 'https://mail.google.com/mail/u/0/#inbox',
      'web.de': 'https://web.de/email/',
      'gmx.de': 'https://www.gmx.net/', 'gmx.net': 'https://www.gmx.net/', 'gmx.at': 'https://www.gmx.at/', 'gmx.ch': 'https://www.gmx.ch/',
      't-online.de': 'https://email.t-online.de/',
      'outlook.com': 'https://outlook.live.com/mail/', 'outlook.de': 'https://outlook.live.com/mail/', 'outlook.at': 'https://outlook.live.com/mail/',
      'hotmail.com': 'https://outlook.live.com/mail/', 'hotmail.de': 'https://outlook.live.com/mail/',
      'live.com': 'https://outlook.live.com/mail/', 'live.de': 'https://outlook.live.com/mail/', 'live.at': 'https://outlook.live.com/mail/',
      'msn.com': 'https://outlook.live.com/mail/',
      'yahoo.com': 'https://mail.yahoo.com/', 'yahoo.de': 'https://mail.yahoo.com/',
      'icloud.com': 'https://www.icloud.com/mail', 'me.com': 'https://www.icloud.com/mail', 'mac.com': 'https://www.icloud.com/mail',
      'aol.com': 'https://mail.aol.com/', 'aol.de': 'https://mail.aol.com/',
      'proton.me': 'https://mail.proton.me/', 'protonmail.com': 'https://mail.proton.me/',
      'freenet.de': 'https://email.freenet.de/'
    };

    var ua = navigator.userAgent || '';
    var isIOS = /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var isAndroid = /Android/.test(ua);

    var href = WEBMAIL[domain] || null;
    if (!href) {
      if (isIOS) href = 'message://';
      else if (isAndroid) href = 'googlegmail://';
    }
    if (!href) return; // Desktop + unbekannte Domain → mailto: belassen

    btn.setAttribute('href', href);
    if (/^(message|googlegmail):/.test(href)) {
      btn.removeAttribute('target');
    } else {
      btn.setAttribute('target', '_blank');
      btn.setAttribute('rel', 'noopener');
    }
    this._mailboxApplied = true;
  };

  RecipebookSignup.prototype._setSubmitting = function (busy) {
    if (this.els.submitBtn) {
      this.els.submitBtn.disabled = busy;
      if (this.els.submitLabel) {
        if (busy) {
          if (!this._origLabel) this._origLabel = this.els.submitLabel.textContent;
          this.els.submitLabel.textContent = '…';
        } else if (this._origLabel) {
          this.els.submitLabel.textContent = this._origLabel;
        }
      }
    }
    if (this.els.emailInput) {
      this.els.emailInput.disabled = busy;
    }
  };

  RecipebookSignup.prototype._showError = function (msg) {
    if (!this.els.errorEl) return;
    this.els.errorEl.textContent = msg;
    this.els.errorEl.removeAttribute('hidden');
    if (this.els.emailInput) this.els.emailInput.setAttribute('aria-invalid', 'true');
  };

  RecipebookSignup.prototype._clearError = function () {
    if (!this.els.errorEl) return;
    this.els.errorEl.textContent = '';
    this.els.errorEl.setAttribute('hidden', '');
    if (this.els.emailInput) this.els.emailInput.removeAttribute('aria-invalid');
  };

  if (!window.customElements.get('recipebook-signup')) {
    window.customElements.define('recipebook-signup', RecipebookSignup);
  }
})();
